import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// Widget styles (imports shared design system)
import './widget.css';

// Widget App with Context Provider
import App from './App';
import { WidgetProvider } from './store';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <WidgetProvider>
      <App />
    </WidgetProvider>
  </StrictMode>
);
